import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsAdvertiser } from 'ha/modules/AuthLogic/selectors';

import { Actions } from '../actions';
import MobilePaymentMenu from '../components/MobilePaymentMenu';
import { MobileMenuType } from '../types';

export const MobilePaymentMenuContainer: React.FC = () => {
  const dispatch = useDispatch();
  const openMainMenu = React.useCallback(() => {
    dispatch(Actions.switchMenu(MobileMenuType.main));
  }, []);

  const isAdvertiser = useSelector(getIsAdvertiser);

  return (
    <MobilePaymentMenu
      openMainMenu={openMainMenu}
      isAdvertiser={isAdvertiser}
    />
  );
};

export default MobilePaymentMenuContainer;
